var _title, _desc, _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "90px",
    viewBox: "0 0 71 90",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "doc-ico")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0909091,0 L52.1245683,0 L66,15.4505208 L66,75.9090909 C66,78.1684376 64.1684376,80 61.9090909,80 L11.0909091,80 C8.83156239,80 7,78.1684376 7,75.9090909 L7,4.09090909 C7,1.83156239 8.83156239,3.07957052e-15 11.0909091,2.66453526e-15 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.4%",
    y: "-8.1%",
    width: "128.8%",
    height: "121.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "53 0 67 14 53 14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-46.4%",
    y: "-39.3%",
    width: "192.9%",
    height: "192.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIDE-Kit-Copy-2",
    transform: "translate(-4420.000000, -1180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc-ico",
    transform: "translate(4420.000000, 1183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D6D6",
    strokeWidth: 1,
    d: "M65.5,15.6420805 L51.9015649,0.5 L11.0909091,0.5 C9.10770476,0.5 7.5,2.10770476 7.5,4.09090909 L7.5,75.9090909 C7.5,77.8922952 9.10770476,79.5 11.0909091,79.5 L61.9090909,79.5 C63.8922952,79.5 65.5,77.8922952 65.5,75.9090909 L65.5,15.6420805 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-21-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFDFDF",
    strokeWidth: 1,
    d: "M53.5,1.20710678 L53.5,13.5 L65.7928932,13.5 L53.5,1.20710678 Z",
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    id: ".doc",
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontSize: 16.3636364,
    fontWeight: 500,
    fill: "#4F5E65"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.6044034,
    y: 69
  }, ".doc")), /*#__PURE__*/React.createElement("g", {
    id: "microsoft-word",
    transform: "translate(0.000000, 13.000000)",
    fill: "#2B579A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "26.0240395 32.6021122 54 32.6021122 54 30.4858086 26 30.4858086 26 27.8958416 53.9759605 27.8958416 53.9759605 25.7825743 26.0180296 25.7825743 26.0180296 23.1713531 53.9939901 23.1713531 53.9939901 21.0823762 26.0180296 21.0823762 26.0180296 18.4650825 53.9939901 18.4650825 53.9939901 16.3518152 26.0180296 16.3518152 26.0180296 13.7648845 53.9939901 13.7648845 53.9939901 11.6516172 26.0180296 11.6516172 26.0180296 9.010033 53.9939901 9.010033 53.9939901 7 26.0180296 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,0.00471947195 L22,35.75 L0,32.0357756 L0,3.82277228 L22,0 L22,0.00471947195 Z M18.6806593,10.5574587 L15.9246154,10.7226403 L14.1597802,21.3980858 L14.1186813,21.3980858 C14.0316484,20.8931023 13.7076923,19.1256601 13.1274725,16.1004785 L12.0975824,10.9680528 L9.51076923,11.0931188 L8.47846154,16.1004785 C7.87406593,19.0171122 7.5356044,20.7137624 7.44857143,21.1927888 L7.4243956,21.1927888 L5.85296703,11.359769 L3.48373626,11.4824752 L6.0221978,23.8828878 L8.65736264,24.0480693 L9.64857143,19.2224092 C10.2287912,16.3907261 10.5672527,14.7459901 10.6397802,14.2952805 L10.7123077,14.2952805 C10.809011,14.7743069 11.1232967,16.4567987 11.7035165,19.3451155 L12.6947253,24.3147195 L15.5474725,24.479901 L18.7386813,10.5574587 L18.6806593,10.5574587 Z",
    id: "Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.105f5563.svg";
export { ForwardRef as ReactComponent };